<template>

  <el-row v-loading="loading">
    <div class="line"></div>
    <el-row>
      <el-col :span="1"></el-col>
      <el-col
        :span="3"
        @click.native="callParentSelectFundOrCompany"
        class="ranking-search-return ranking-search-return-font-color"
      >&lt; 返回上一级 </el-col>
      <el-col
        :span="16"
        class="left_text_align ranking-search-return"
      >
        <span v-html="searchTitle"></span>&nbsp;
      </el-col>
    </el-row>
    <div class="line"></div>
    <br>
    <el-table
      :data="tableData"
      border
      @sort-change="sortChange"
      :default-sort="{ prop: 'PriceDate', order: 'descending' }"
      style="width: 100%;"
      class="tableSpecial margin-left-50-important padding-right-50-important"
    >

      <el-table-column
        fixed
        sortable="custom"
        prop="defaultSymbol"
        label="基金代码"
        width="110"
        :render-header="renderheaderRefreshData"    
      >
      </el-table-column>
      <el-table-column
        fixed
        sortable="custom"
        prop="legalName"
        label="基金名称"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        sortable="categoryName"
        prop="categoryName"
        label="基金类型"
        min-width="250"
      >
          <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.categoryName)"></span>                                
            <el-tooltip v-if="scope.row.categoryNoRating || scope.row.categoryNoRanking " class="item" effect="light" :content="categoryAlertMsg(scope.row)" placement="right">                                    
             <i class="el-icon-info-ms"></i>                 
            </el-tooltip>
          </template>
      </el-table-column>
      <el-table-column
        prop="inceptionDate"
        label="成立日期"
        min-width="120"
        sortable="custom"
      >
        <template slot-scope="scope">{{ scope.row.inceptionDate | replaceTime }}</template>
      </el-table-column>

     <el-table-column
        label=""
        align="center"
        label-class-name="col-divider-left"
      >
            <template slot="header">
              <span>晨星评级({{ratingDate}})</span>
            </template>

           <el-table-column
            prop="starRating3"
            label="三年评级"
            min-width="120"
            sortable="custom"            
            align="center"
            class-name="col-divider-left"
            label-class-name="col-divider-left"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating3)">{{ scope.row.starRating3 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating3)"
                :src="getStarRating(scope.row.starRating3)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="starRating5"
            label="五年评级"
            min-width="120"
            sortable="custom"            
            align="center"
            style="background-color:red !important;"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating5)">{{ scope.row.starRating5 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating5)"
                :src="getStarRating(scope.row.starRating5)"
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="starRating10"
            label="十年评级"
            min-width="120"
            sortable="custom"            
            align="center"
          >
            <template slot-scope="scope">
              <div v-if="!checkDataHasValue(scope.row.starRating10)">{{ scope.row.starRating10 | fillNull }}</div>
              <img
                v-if="checkDataHasValue(scope.row.starRating10)"
                :src="getStarRating(scope.row.starRating10)"
              />
            </template>
          </el-table-column>
      </el-table-column>
      <el-table-column
        prop="priceDate"
        label="最新净值|日期"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ scope.row.priceDate | replaceTime }}</template>
      </el-table-column>
      <el-table-column
        prop="nav"
        label="单位净值|(元)"
        min-width="120"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <!-- <span>{{ scope.row.nav | fillNullRound4 }}</span> -->
          <span>{{ scope.row.nav | fillNullRound(4) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="return1Day"
        label="日回报|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.return1Day | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Day)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        label="今年以来"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="returnYTD"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.returnYTD | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnYTD)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="returnYTDRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
          class="borderLeft"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.returnYTDRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentileM0Rank) : rankTooltip(scope.row.returnYTDRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.returnYTD,scope.row.categoryNoRanking,scope.row.returnYTDRankNavOutlier,scope.row.returnYTDRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.returnYTD,showNoRankingIcon,scope.row.returnYTDRankNavOutlier,scope.row.returnYTDRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        label="最近一周"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return1Week"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return1Week | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Week)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return1WeekRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return1WeekRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile1WRank) : rankTooltip(scope.row.return1WeekRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return1Week,scope.row.categoryNoRanking,scope.row.return1WeekRankNavOutlier,scope.row.return1WeekRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return1Week,scope.row.categoryNoRanking,scope.row.return1WeekRankNavOutlier,scope.row.return1WeekRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近一月"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return1Month"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return1Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Month)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return1MonthRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return1MonthRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile1MRank) : rankTooltip(scope.row.return1MonthRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return1Month,scope.row.categoryNoRanking,scope.row.return1MonthRankNavOutlier,scope.row.return1MonthRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return1Month,scope.row.categoryNoRanking,scope.row.return1MonthRankNavOutlier,scope.row.return1MonthRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近三月"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return3Month"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return3Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Month)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return3MonthRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return3MonthRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile3MRank) : rankTooltip(scope.row.return3MonthRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return3Month,scope.row.categoryNoRanking,scope.row.return3MonthRankNavOutlier,scope.row.return3MonthRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return3Month,scope.row.categoryNoRanking,scope.row.return3MonthRankNavOutlier,scope.row.return3MonthRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近六月"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return6Month"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return6Month | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return6Month)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return6MonthRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return6MonthRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile6MRank) :  rankTooltip(scope.row.return6MonthRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return6Month,scope.row.categoryNoRanking,scope.row.return6MonthRankNavOutlier,scope.row.return6MonthRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return6Month,scope.row.categoryNoRanking,scope.row.return6MonthRankNavOutlier,scope.row.return6MonthRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近一年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return1Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return1Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return1Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return1YearRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return1YearRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile1YRank) : rankTooltip(scope.row.return1YearRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return1Year,scope.row.categoryNoRanking,scope.row.return1YearRankNavOutlier,scope.row.return1YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return1Year,scope.row.categoryNoRanking,scope.row.return1YearRankNavOutlier,scope.row.return1YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近两年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return2Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn2Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn2Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn2Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return2YearRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return2YearRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile2YRank) : rankTooltip(scope.row.return2YearRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return2Year,scope.row.categoryNoRanking,scope.row.return2YearRankNavOutlier,scope.row.return2YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return2Year,scope.row.categoryNoRanking,scope.row.return2YearRankNavOutlier,scope.row.return2YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近三年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return3Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn3Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn3Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn3Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return3YearRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return3YearRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile3YRank) : rankTooltip(scope.row.return3YearRank) "></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return3Year,scope.row.categoryNoRanking,scope.row.return3YearRankNavOutlier,scope.row.return3YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return3Year,scope.row.categoryNoRanking,scope.row.return3YearRankNavOutlier,scope.row.return3YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近五年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return5Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn5Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn5Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn5Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return5YearRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return5YearRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile5YRank) : rankTooltip(scope.row.return5YearRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return5Year,scope.row.categoryNoRanking,scope.row.return5YearRankNavOutlier,scope.row.return5YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return5Year,scope.row.categoryNoRanking,scope.row.return5YearRankNavOutlier,scope.row.return5YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近七年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return7Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn7Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn7Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn7Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return7YearRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return7YearRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile7YRank) : rankTooltip(scope.row.return7YearRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return7Year,scope.row.categoryNoRanking,scope.row.return7YearRankNavOutlier,scope.row.return7YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return7Year,scope.row.categoryNoRanking,scope.row.return7YearRankNavOutlier,scope.row.return7YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return10Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn10Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn10Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn10Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return10YearRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return10YearRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile10YRank) : rankTooltip(scope.row.return10YearRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.return10Year,showNoRankingIcon,scope.row.return10YearRankNavOutlier,scope.row.return10YearRankSignificantRestructure)" class="item" effect="light" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.return10Year,showNoRankingIcon,scope.row.return10YearRankNavOutlier,scope.row.return10YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>              
        </el-table-column>
      </el-table-column>
      <el-table-column
        label="最近十五年"
        align="center"
        label-class-name="col-divider-left"
      >
        <el-table-column
          prop="return15Year"
          label="年化回报率"
          min-width="120"
          sortable="custom"
          align="center"
          class-name="col-divider-left"
          label-class-name="col-divider-left"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.return15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.return15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="accReturn15Year"
          label="总回报率"
          min-width="120"
          sortable="custom"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.accReturn15Year | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.accReturn15Year)">%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="return15YearRank"
          :label="groupRankLabel"
          min-width="120"
          align="center"
        >
          <!-- <template slot-scope="scope">
            <span v-html="rankTooltip(scope.row.return15YearRank)"></span>
          </template> -->
              <template slot-scope="scope">
                <span v-html="groupRankLabel === '同类百分比排名' ? rankTooltip(scope.row.percentile15YRank) : rankTooltip(scope.row.return15YearRank)"></span>                                
                <el-tooltip v-if="groupRankLabel !== '同类百分比排名' && showNavOutlier(scope.row.accReturn15Year,scope.row.categoryNoRanking,scope.row.return15YearRankNavOutlier,scope.row.return15YearRankSignificantRestructure)" class="item" effect="light" content="疑似净值异常波动，不参与排名" placement="right">                                    
                  <div slot="content">{{showTooltipContent(scope.row.accReturn15Year,scope.row.categoryNoRanking,scope.row.return15YearRankNavOutlier,scope.row.return15YearRankSignificantRestructure)}}</div><i class="el-icon-info-ms"></i>                 
                </el-tooltip>
              </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="returnInception"
        label="成立以来|总回报率"
        min-width="120"
        sortable="custom"
        :render-header="renderheader2Row"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.returnInception | fillNullRound(2) }}</span><span v-if="checkDataHasValue(scope.row.returnInception)">%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="categoryNameLocal"
        label="晨星分类"
        min-width="220"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="categoryGroupName"
        label="晨星分类组别"
        min-width="140"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="broadCategoryName_CN"
        label="晨星资产大类"
        min-width="140"
        show-overflow-tooltip
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      ></el-table-column>
      <el-table-column
        prop="ifOldestShare"
        label="是否最早份额"
        min-width="120"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ formatBooleanFlag(scope.row.ifOldestShare) }}</template>
      </el-table-column>
      <el-table-column
        prop="ifPeerGroupMembershipChange"
        label="是否转型基金"
        min-width="120"
        align="center"
        class-name="col-divider-left"
        label-class-name="col-divider-left"
      >
        <template slot-scope="scope">{{ formatBooleanFlag(scope.row.ifPeerGroupMembershipChange) }}</template>
      </el-table-column>
    </el-table>
    <el-col class="left_text_align padding_25px_top">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="(pagination && pagination.count) || 0"
        v-if="pagination.count > 10 ? true : false"
        class="margin-left-50-important"
      >
      </el-pagination>
    </el-col>
  </el-row>
</template>
<script>
import { Message } from "element-ui";
import { getFundCache, getFundRank } from "../api/ranking";
import { loadingData } from "./mixin/loadingData";

const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;
const removeNameAndValue=componentsCommon.localStorage.removeNameAndValue;
const setNameAndValue=componentsCommon.localStorage.setNameAndValue;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const formatDecimal=componentsCommon.apiCommon.formatDecimal;
const dateWithForwardSlash=componentsCommon.apiCommon.dateWithForwardSlash;

const RANKING_SEARCH_EXPORT_COLUMN_MAP_KEY = "rankingSearchExportColumnMap";

export default {
    mixins: [loadingData],
    props: ["tempCompanyNameStr"],
    data() {
        return {
            searchTitle: "",
            isShowRankingTab: true,
            dialogLoading: false,
            loading: false,
            companyNameStr: '',
            groupRankLabel: "同类排名",
            tableData: [],
            pageSize: 0,
            selectFormat: "xlsx",
            ratingDate:'',
            pagination: {
                skip: 0,
                limit: 10,
                count: 0,
            },
            params: {
                type: "",
                category: "", //"EquityFunds",
                keyword: "",
                date: "", //"2020-06-30",
                month: "", //"2020-06-30",
                quarter: "", //"2020-06-30",
                sort: "PriceDate",
                order: "desc",
                limit: 10,
                skip: 0,
                page: 1,
            }
        };
    },
    watch: {
      tableData (val) {
        if (val && val[0]) {
          const mrfofNorth = val[0].mrfofNorth;
          this.groupRankLabel = mrfofNorth == 1 ? "同类百分比排名" : "同类排名";
        }
      },
      groupRankLabel() {
        this.persistRankingSearchExportColumnMap();
      },
      tempCompanyNameStr (val, oldVal) {
            let self = this;
            self.searchTitle = "基金公司：<b>" + val + "</b>";
        },
    },
    filters: {
        fillNull(value) {
            if (value != undefined && value != null && value != "") {
                return value;
            } else {
                return "--";
            }
        },
        fillNullRound(value, fixedDecimal) {
            if (value != undefined && value != null && value != "") {
                return formatDecimal(value, fixedDecimal);
            } else {
                return "--";
            }
        },
        replaceTime(value) {
            if (value != undefined && value != null && value != "") {
                return dateWithForwardSlash(value);
            } else {
                return "--";
            }
        },
    },
    mounted() {
      this.persistRankingSearchExportColumnMap();
      /*const self = this;
      self.getData(self.params);*/
    },
    methods: {
      getRankingSearchExportColumnMap() {
        const rankLabel = this.groupRankLabel;
        const rankFieldByPeriod = {
          "今年以来": rankLabel === "同类百分比排名" ? "percentileM0Rank" : "returnYTDRank",
          "最近一周": rankLabel === "同类百分比排名" ? "percentile1WRank" : "return1WeekRank",
          "最近一月": rankLabel === "同类百分比排名" ? "percentile1MRank" : "return1MonthRank",
          "最近三月": rankLabel === "同类百分比排名" ? "percentile3MRank" : "return3MonthRank",
          "最近六月": rankLabel === "同类百分比排名" ? "percentile6MRank" : "return6MonthRank",
          "最近一年": rankLabel === "同类百分比排名" ? "percentile1YRank" : "return1YearRank",
          "最近两年": rankLabel === "同类百分比排名" ? "percentile2YRank" : "return2YearRank",
          "最近三年": rankLabel === "同类百分比排名" ? "percentile3YRank" : "return3YearRank",
          "最近五年": rankLabel === "同类百分比排名" ? "percentile5YRank" : "return5YearRank",
          "最近七年": rankLabel === "同类百分比排名" ? "percentile7YRank" : "return7YearRank",
          "最近十年": rankLabel === "同类百分比排名" ? "percentile10YRank" : "return10YearRank",
          "最近十五年": rankLabel === "同类百分比排名" ? "percentile15YRank" : "return15YearRank",
        };

        return [
          { label: "基金代码", field: "defaultSymbol", valuePath: "scope.row.defaultSymbol" },
          { label: "基金名称", field: "legalName", valuePath: "scope.row.legalName" },
          { label: "基金类型", field: "categoryName", valuePath: "scope.row.categoryName" },
          { label: "成立日期", field: "inceptionDate", valuePath: "scope.row.inceptionDate" },

          { label: "晨星评级|三年评级", field: "starRating3", valuePath: "scope.row.starRating3" },
          { label: "晨星评级|五年评级", field: "starRating5", valuePath: "scope.row.starRating5" },
          { label: "晨星评级|十年评级", field: "starRating10", valuePath: "scope.row.starRating10" },

          { label: "最新净值|日期", field: "priceDate", valuePath: "scope.row.priceDate" },
          { label: "单位净值|(元)", field: "nav", valuePath: "scope.row.nav" },
          { label: "日回报|总回报率", field: "return1Day", valuePath: "scope.row.return1Day" },

          { label: "今年以来|总回报率", field: "returnYTD", valuePath: "scope.row.returnYTD" },
          { label: "今年以来|" + rankLabel, field: rankFieldByPeriod["今年以来"], valuePath: "scope.row." + rankFieldByPeriod["今年以来"] },

          { label: "最近一周|总回报率", field: "return1Week", valuePath: "scope.row.return1Week" },
          { label: "最近一周|" + rankLabel, field: rankFieldByPeriod["最近一周"], valuePath: "scope.row." + rankFieldByPeriod["最近一周"] },

          { label: "最近一月|总回报率", field: "return1Month", valuePath: "scope.row.return1Month" },
          { label: "最近一月|" + rankLabel, field: rankFieldByPeriod["最近一月"], valuePath: "scope.row." + rankFieldByPeriod["最近一月"] },

          { label: "最近三月|总回报率", field: "return3Month", valuePath: "scope.row.return3Month" },
          { label: "最近三月|" + rankLabel, field: rankFieldByPeriod["最近三月"], valuePath: "scope.row." + rankFieldByPeriod["最近三月"] },

          { label: "最近六月|总回报率", field: "return6Month", valuePath: "scope.row.return6Month" },
          { label: "最近六月|" + rankLabel, field: rankFieldByPeriod["最近六月"], valuePath: "scope.row." + rankFieldByPeriod["最近六月"] },

          { label: "最近一年|总回报率", field: "return1Year", valuePath: "scope.row.return1Year" },
          { label: "最近一年|" + rankLabel, field: rankFieldByPeriod["最近一年"], valuePath: "scope.row." + rankFieldByPeriod["最近一年"] },

          { label: "最近两年|年化回报率", field: "return2Year", valuePath: "scope.row.return2Year" },
          { label: "最近两年|总回报率", field: "accReturn2Year", valuePath: "scope.row.accReturn2Year" },
          { label: "最近两年|" + rankLabel, field: rankFieldByPeriod["最近两年"], valuePath: "scope.row." + rankFieldByPeriod["最近两年"] },

          { label: "最近三年|年化回报率", field: "return3Year", valuePath: "scope.row.return3Year" },
          { label: "最近三年|总回报率", field: "accReturn3Year", valuePath: "scope.row.accReturn3Year" },
          { label: "最近三年|" + rankLabel, field: rankFieldByPeriod["最近三年"], valuePath: "scope.row." + rankFieldByPeriod["最近三年"] },

          { label: "最近五年|年化回报率", field: "return5Year", valuePath: "scope.row.return5Year" },
          { label: "最近五年|总回报率", field: "accReturn5Year", valuePath: "scope.row.accReturn5Year" },
          { label: "最近五年|" + rankLabel, field: rankFieldByPeriod["最近五年"], valuePath: "scope.row." + rankFieldByPeriod["最近五年"] },

          { label: "最近七年|年化回报率", field: "return7Year", valuePath: "scope.row.return7Year" },
          { label: "最近七年|总回报率", field: "accReturn7Year", valuePath: "scope.row.accReturn7Year" },
          { label: "最近七年|" + rankLabel, field: rankFieldByPeriod["最近七年"], valuePath: "scope.row." + rankFieldByPeriod["最近七年"] },

          { label: "最近十年|年化回报率", field: "return10Year", valuePath: "scope.row.return10Year" },
          { label: "最近十年|总回报率", field: "accReturn10Year", valuePath: "scope.row.accReturn10Year" },
          { label: "最近十年|" + rankLabel, field: rankFieldByPeriod["最近十年"], valuePath: "scope.row." + rankFieldByPeriod["最近十年"] },

          { label: "最近十五年|年化回报率", field: "return15Year", valuePath: "scope.row.return15Year" },
          { label: "最近十五年|总回报率", field: "accReturn15Year", valuePath: "scope.row.accReturn15Year" },
          { label: "最近十五年|" + rankLabel, field: rankFieldByPeriod["最近十五年"], valuePath: "scope.row." + rankFieldByPeriod["最近十五年"] },

          { label: "成立以来|总回报率", field: "returnInception", valuePath: "scope.row.returnInception" },
          { label: "晨星分类", field: "categoryNameLocal", valuePath: "scope.row.categoryNameLocal" },
          { label: "晨星分类组别", field: "categoryGroupName", valuePath: "scope.row.categoryGroupName" },
          { label: "晨星资产大类", field: "broadCategoryName_CN", valuePath: "scope.row.broadCategoryName_CN" },
          { label: "是否最早份额", field: "ifOldestShare", valuePath: "scope.row.ifOldestShare" },
          { label: "是否转型基金", field: "ifPeerGroupMembershipChange", valuePath: "scope.row.ifPeerGroupMembershipChange" },
        ];
      },
      persistRankingSearchExportColumnMap() {
        setNameAndValue(
          RANKING_SEARCH_EXPORT_COLUMN_MAP_KEY,
          {
            rankMode: this.groupRankLabel,
            columns: this.getRankingSearchExportColumnMap(),
          }
        );
      },
        categoryAlertMsg(row) {
          if (row.categoryNoRanking) {
             if (row.categoryNoRating) {
               return "该类型基金不参与排名、评级";
             } else {
               return "该类型基金不参与排名";
             }
          } else if (row.categoryNoRating){
            return "该类型基金不参与评级";
          }
          return "数据错误，请联系产品支持团队";
        },

        callParentSelectFundOrCompany() {
            this.$parent.$parent.selectFundOrCompany("");
        },
        showUnidentifiedData() {
            let unidentifiedList = getNameAndValue("unidentifiedList");
            unidentifiedList = JSON.parse(unidentifiedList);
            const blob = new Blob(["\ufeff" + unidentifiedList.join("\n")], {
                type: "text/csv;charset=utf-8",
            });
            createLinkForDownload(blob, "unidentifiedList.csv");
        },
        loadingData(
            categoryId,
            keyword,
            effectiveDate,
            isShowRankingTab,
            symbolInfo
        ) {
            const self = this;
            self.searchTitle = "";
            if (keyword != null && keyword != "") {
                self.params.keyword = keyword;
                self.params.categoryId = "";
                self.activeName = "";
                self.activeNameEqutity = "";
                // self.searchTitle = "基金公司：<b>" + self.companyNameStr + "</b>";
            } else {
                self.params.keyword = "";
                self.params.categoryId = categoryId;
            }
            if (symbolInfo && symbolInfo != "undefined_undefined") {
                if (symbolInfo.indexOf("_") > -1) {
                    self.params.keyword = symbolInfo.split("_")[0];
                    self.searchTitle =
                        "基金名称：<b>" + symbolInfo.split("_")[1] + "</b>";
                } else {
                    self.params.keyword = symbolInfo;
                    self.searchTitle = "";
                }
                self.params.type = "";
                self.params.categoryId = "";
                self.activeName = "";
                self.activeNameEqutity = "";
            }
            if (effectiveDate != null && effectiveDate != "") {
                self.params.date = effectiveDate;
            } else {
                self.params.date = "";
            }
            /*self.params.month=effectiveDate;
            self.params.quarter=effectiveDate;*/
            self.getData(self.params);
        },
    },
};
</script>
<style lang="scss">
@import "../../public/sass/components/ranking";
</style>
<style scoped>
/*给table了列添加左边的border begin*/
.tableSpecial >>> table tr:nth-child(1) th {
    line-height: 35px;
    border-top: 1px solid #ebeef5 !important;
}

.tableSpecial >>> .col-divider-left {
    border-left: 1px solid #ebeef5 !important;
}
</style>

